import React, { useContext } from 'react';
import { motion } from "framer-motion";
import { useLocation, useNavigate } from 'react-router-dom';
import { 
    FiGrid, 
    FiUser, 
    FiClock, 
    FiPhone, 
    FiFileText, 
    FiLogOut,
    FiX 
} from "react-icons/fi";

import ContextDashboard from '../../Context/ContextDashboard';
import { getStorage } from '../../Utils/common';
import logo_dark from "../../images/logo-dark.svg";

const linkList = [
   {
      link: "/my-dashboard/",
      icon: <FiGrid />,
      title: "Dashboard"
   },
   {
      link: "/my-dashboard/profile-preview",
      icon: <FiUser />,
      title: "My Account"
   },
   {
      link: "/my-dashboard/leads",
      icon: <FiClock />,
      title: "Loan History"
   },
   {
      link: "/contact-customer-care-ActoLoan",
      icon: <FiPhone />,
      title: "Support"
   },
   {
      link: "/termsandconditions",
      icon: <FiFileText />,
      title: "Terms & Conditions"
   },
   {
      link: "/privacypolicy",
      icon: <FiFileText />,
      title: "Privacy Policy"
   }
];

function SideBar({ toggle, setToggle }) {
   const navigate = useNavigate();
   const location = useLocation();
   const { logout } = useContext(ContextDashboard);

   const redirect = (link) => {
      let finalLink = link;
      if (link === "/my-dashboard/") {
          if (getStorage('eligibility') === 1) {
            finalLink = '/my-dashboard/eligibility'; 
         }
      }

      if (link === "/my-dashboard/profile-preview") {
          if (getStorage('eligibility') === 1) {
            finalLink = '/my-dashboard/lead-preview'; 
         }
      }
   
      if (window.innerWidth <= 1024) {
         setToggle(true); // Close sidebar on mobile after click
      }
   
      navigate(finalLink);
   };

   return (
      <aside className={`modern_sidebar ${toggle ? "close" : "open"}`} style={{ zIndex: 99999 }}>
         {/* --- Executive Close Anchor (Mobile Only) --- */}
         {!toggle && window.innerWidth <= 1024 && (
            <motion.button
               initial={{ opacity: 0, scale: 0.5, rotate: -90 }}
               animate={{ opacity: 1, scale: 1, rotate: 0 }}
               whileHover={{ scale: 1.1, rotate: 90 }}
               whileTap={{ scale: 0.9 }}
               onClick={() => setToggle(true)}
               style={{
                  position: 'absolute',
                  top: '25px',
                  right: '25px',
                  width: '40px',
                  height: '40px',
                  borderRadius: '12px',
                  background: '#f8fafc',
                  border: '1px solid #cbd5e1',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#2889a6',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                  cursor: 'pointer',
                  zIndex: 1000
               }}
            >
               <FiX size={20} />
            </motion.button>
         )}

         <motion.div 
            className="sidebar_logo_wrap"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            whileHover={{ scale: 1.05, rotate: [0, -2, 2, 0] }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
         >
            <img src={logo_dark} alt="ActoLoan" style={{ filter: 'drop-shadow(0 10px 15px rgba(0,0,0,0.05))' }} />
         </motion.div>

         <ul className="sidebar_nav_list" style={{ position: 'relative' }}>
            {linkList.map((item, index) => {
                const isActive = item.link === "/my-dashboard/" 
                    ? (location.pathname === "/my-dashboard" || location.pathname === "/my-dashboard/" || location.pathname === "/my-dashboard/eligibility")
                    : location.pathname.includes(item.link);
                
                return (
                    <motion.li 
                        key={index}
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: index * 0.05 }}
                        whileHover={{ x: 5 }}
                        whileTap={{ scale: 0.98 }}
                        onClick={() => redirect(item.link)} 
                        className={`sidebar_nav_item ${isActive ? "active" : ""}`}
                        style={{ position: 'relative' }}
                    >
                        <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '16px', zIndex: 1, width: '100%' }}>
                            {item.icon}
                            <span>{item.title}</span>
                            {isActive && (
                                <motion.div 
                                    layoutId="active_dot"
                                    initial={{ scale: 0 }}
                                    animate={{ scale: 1 }}
                                    style={{ 
                                        width: '6px', 
                                        height: '6px', 
                                        borderRadius: '50%', 
                                        background: '#fff', 
                                        marginLeft: 'auto',
                                        boxShadow: '0 0 10px rgba(255,255,255,0.5)' 
                                    }} 
                                />
                            )}
                        </div>
                    </motion.li>
                );
            })}
         </ul>

         <div className="sidebar_logout_btn">
            <motion.div 
                className="sidebar_nav_item" 
                whileHover={{ x: 5 }}
                onClick={logout}
                style={{ cursor: "pointer", color: '#ef4444' }}
            >
                <FiLogOut />
                <span>Logout</span>
            </motion.div>
         </div>
      </aside>
   );
}

export default SideBar;
